module.exports = __webpack_public_path__ + "static/Danzza-Regular-9b264b8f68bef989e3f6b5f5e7fafcf0.woff2";